var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number",staticStyle:{"margin-top":"0.4rem","text-align":"center"}},[_vm._v("\n  暂无数据~\n")])}
var staticRenderFns = []

export { render, staticRenderFns }